import React, { Component } from "react";
import SwitchSlider from "../SwitchSlider";
import Popup from "reactjs-popup";
import { connect } from "react-redux";
import { ModalPopupNeeds } from "../ModalPopupNeeds";
import { setvalueCofirm } from "../../../actions/policy/policyActions";
import Store from "../../../content/Store";
import styles from "../../../assets/css/modules/myprofile/myprofilecommunicationprefs.css";
import Content from "../../../content/Content";
const mapDispatchToProps = (dispatch) => {
  return {
    setvalueCofirm: (val, CommDescription) =>
      dispatch(setvalueCofirm(val, CommDescription)),
  };
};

const Messagecol = {
  color: "#C91432",
  fontSize: "15px",
  paddingLeft: "10px",
  marginTop: "15px",
};
const radioErr = {
  border: "2px solid #C91432",
};

const radioIndMFA = {
  border: "2px solid #3032c1",
};

export const mapStateToProps = ({ preferenceConfirmReducer = {} }) => {
  return {
    prefval: preferenceConfirmReducer && preferenceConfirmReducer.PrefSelection,
    commval:
      preferenceConfirmReducer && preferenceConfirmReducer.Communicationval,
  };
};

export class FormGroupNeedsComm extends Component {
  constructor(props) {
    super(props);
    this.state = { isPopupOpen: false, prefSelection: null };
    this.closePopup = this.closePopup.bind(this);
    this.getPreferSelection = this.getPreferSelection.bind(this);
    this.onPopupContinue = this.onPopupContinue.bind(this);
  }

  closePopup() {
    this.setState({ isPopupOpen: false });
  }

  getPreferSelection(val) {
    this.props.setvalueCofirm(val);
    this.props.poupconfirmations(val);
  }

  onPopupContinue(url) {
    window.open(url);
    this.closePopup();
  }

  render() {
    if (this.props.type === "yesno") {
      if (this.props.Zebrafied) {
        return (
          <div className={`zebrafied-formneed-row ${styles.formneedRow}`}>
            <div className="row justify-content-between align-items-center">
              <div className="col-12">
                <div className="align-middle">
                  {this.props.UseSlider ? (
                    <SwitchSlider
                      id={this.props.id}
                      onChange={this.props.onChange}
                      currentValue={this.props.currentValue}
                    />
                  ) : (
                    <React.Fragment>
                      <div>
                        {this.state.isPopupOpen ? (
                          <Popup
                            open={this.state.isPopupOpen}
                            modal
                            closeOnDocumentClick
                            onClose={this.closePopup}
                          >
                            <ModalPopupNeeds
                              cancel={() => this.closePopup()}
                              heading={this.props.label}
                              communicationPrefid={this.props.commId}
                              description={this.props.CommDescription}
                              CommConfirmation={this.props.CommConfirmation}
                              setpreferenceConfirm={(val) =>
                                this.getPreferSelection(val)
                              }
                            />
                          </Popup>
                        ) : null}
                      </div>

                      <span className={"form-group label-normal"}>
                        <label
                          style={{ fontSize: "11pt", margin: "0px 25px 0 0" }}
                          className={`custom-control custom-radio radio2 align-middle ${styles.commsSectionsYesLabelForm}`}
                          htmlFor={this.props.id + "Yes"}
                        >
                          <input
                            id={this.props.id + "Yes"}
                            name={this.props.id}
                            type="radio"
                            onChange={this.props.onChange}
                            className="custom-control-input"
                            value={"Yes"}
                            //checked = {this.props.commId === (this.props.prefval!==null && this.props.prefval.split('&')[1]) && this.props.prefval.includes('Yes') ? true :  this.props.commval !== null && this.props.commval.some(val => val.CommunicationPreferenceId.toString() === this.props.commId) ? true :false}
                            //checked={(this.props.commId === (this.props.prefval !== null && this.props.prefval.split('&')[1]) && this.props.prefval.includes('Yes') ? true : this.props.commval !== null && this.props.commval.some(val => val.CommunicationPreferenceId.toString() === this.props.commId) ? true : false)}
                            checked={
                              this.props.currentValue === true &&
                              this.props.prefval === null
                                ? true
                                : this.props.commId ===
                                    (this.props.prefval !== null &&
                                      this.props.prefval.split("&")[1]) &&
                                  this.props.prefval.includes("Yes")
                                ? true
                                : this.props.commval !== null &&
                                  this.props.commval.some(
                                    (val) =>
                                      val.CommunicationPreferenceId.toString() ===
                                        this.props.commId &&
                                      val.IsDeleted === false
                                  )
                                ? true
                                : false
                            }
                            //value="true"
                            // radioGroup="true"
                            //defaultChecked={this.props.currentValue}
                            onClick={() => {
                              this.setState({ isPopupOpen: true });
                            }}
                            //onClick={() => { this.props.commId === "0" ? this.setState({ isPopupOpen: false }) : this.setState({ isPopupOpen: true }); }}
                          />
                          
                          {this.props.SelectionOption &&
                          this.props.PrefSecValue &&
                          this.props.commId !== "4" &&
                          this.props.commId !== "7" ? (
                            <span
                              className={`custom-control-indicator ${styles.radioIndMFA}`}
                              style={radioErr}
                            />
                          ) : (
                            <span
                              className={`custom-control-indicator ${
                                this.props.commId === "0"
                                  ? styles.radioIndMFAFormIdZero
                                  : styles.radioIndMFAForm
                              }`}
                              style={radioIndMFA}
                            />
                          )}
                          <span className="custom-control-description">
                            {this.props.commId === "4" ||
                            this.props.commId === "7"
                              ? "Yes"
                              : null}</span>
                          {this.props.commId === "4" ||
                        this.props.commId === "7" ? (
                          <label
                            style={{ fontSize: "11pt", margin: "0px 25px 0 0" }}
                            className={`custom-control custom-radio radio2 align-middle`}
                            htmlFor={this.props.id + "No"}
                          >
                            <input
                              id={this.props.id + "No"}
                              name={this.props.id}
                              type="radio"
                              onChange={this.props.onChange}
                              className="custom-control-input"
                              value={"No"}
                              //checked = { this.props.commId === (this.props.prefval!==null && this.props.prefval.split('&')[1]) && this.props.prefval.includes('No') ? true :  this.props.commval!==null && this.props.commval.some(val => val.CommunicationPreferenceId.toString() === this.props.commId) ? false :true }
                              //checked={this.props.prefval == null ? null : this.props.commId === (this.props.prefval.split('&')[1]) && this.props.prefval.includes('No') ? true : this.props.commval !== null && this.props.commval.some(val => val.CommunicationPreferenceId.toString() === this.props.commId) ? false : true}
                              checked={
                                this.props.currentValue === false
                                  ? true
                                  : this.props.prefval == null
                                  ? null
                                  : this.props.commId ===
                                      this.props.prefval.split("&")[1] &&
                                    this.props.prefval.includes("No")
                                  ? true
                                  : this.props.commval !== null &&
                                    this.props.commval.some(
                                      (val) =>
                                        val.CommunicationPreferenceId.toString() ===
                                          this.props.commId &&
                                        val.IsDeleted === false
                                    )
                                  ? false
                                  : true
                              }
                              //checked = {this.props.currentValue === false}
                              // value="false"
                              // defaultChecked={this.props.currentValue}
                            />
                            {this.props.SelectionOption &&
                            this.props.PrefSecValue ? (
                              <span
                                className={`custom-control-indicator ${styles.radioIndMFA}`}
                              />
                            ) : (
                              <span
                                className={`custom-control-indicator ${styles.radioIndMFA}`}
                                style={radioIndMFA}
                              />
                            )}
                            <span className="custom-control-description">
                              No
                            </span>
                          </label>
                        ) : null}
                          {this.props.commId !== "4" &&
                          this.props.commId !== "7" ? (
                            <div className={styles.firstSectionWidth}>
                              <h2 className={styles.headingMargin}>
                                <label
                                  htmlFor={this.props.id}
                                  className="m-0 align-middle"
                                >
                                  {this.props.label}
                                </label>
                              </h2>
                              <lable
                                htmlFor={this.props.id}
                                className="m-0 align-middle "
                              >
                                {this.props.description}
                              </lable>
                            </div>
                          ) : (
                            <div className={styles.secondSectionWidth}>
                              <h2 className={styles.headingMargin}>
                                <label
                                  htmlFor={this.props.id}
                                  className="m-0 align-middle"
                                >
                                  {this.props.label}
                                </label>
                              </h2>
                              <lable
                                htmlFor={this.props.id}
                                className="m-0 align-middle"
                              >
                                {this.props.description}
                              </lable>
                            </div>
                          )}
                          
                        </label>
                        
                      </span>
                    </React.Fragment>
                  )}
                </div>
              </div>

              {this.props.SelectionOption &&
              this.props.PrefSecValue &&
              this.props.commId === "5" ? (
                <div style={Messagecol}>
                  <Content
                    name={
                      Store.MyProfileCommunicationNeeds
                        .NoChangesSelectionMessage
                    }
                  ></Content>
                </div>
              ) : null}
            </div>
          </div>
        );
      }
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FormGroupNeedsComm);
